var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 31.006,
    viewBox: "0 0 96 31.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa",
    d: "M36.451,173.864,23.884,203.85h-8.2L9.5,179.922a3.314,3.314,0,0,0-1.846-2.639A32.615,32.615,0,0,0,0,174.735l.19-.87h13.2a3.615,3.615,0,0,1,3.577,3.058l3.268,17.355L28.3,173.864h8.15Zm32.127,20.191c.036-7.91-10.945-8.34-10.866-11.879.021-1.08,1.045-2.223,3.287-2.512A14.638,14.638,0,0,1,68.649,181l1.361-6.356a20.849,20.849,0,0,0-7.255-1.328c-7.667,0-13.064,4.078-13.109,9.913-.05,4.315,3.851,6.723,6.793,8.16,3.021,1.47,4.032,2.409,4.021,3.728-.02,2.013-2.411,2.892-4.641,2.932a16.234,16.234,0,0,1-7.97-1.9l-1.4,6.574a23.662,23.662,0,0,0,8.629,1.6c8.149,0,13.479-4.035,13.5-10.269m20.246,9.795H96l-6.262-29.986H83.114a3.538,3.538,0,0,0-3.3,2.2L68.178,203.851h8.142l1.616-4.478H87.89Zm-8.656-10.624,4.085-11.259,2.35,11.259ZM47.536,173.864,41.118,203.85H33.359l6.42-29.986Z",
    transform: "translate(0 -173.319)",
    fill: "#1a2adf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e0eae1d064d56e06303df8956b535524.svg";
export { ForwardRef as ReactComponent };